import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useChartingCredentialIntegrationConfig() {
  return useCbhFlag(CbhFeatureFlag.CHARTING_CREDENTIAL_INTEGRATION_CONFIG, {
    defaultValue: {
      enabled: false,
    },
  });
}
